import React from 'react';
import { Title, Text, Grid, Card, Group, Badge, ThemeIcon } from '@mantine/core';
import { IconWeight, IconCoin, IconPackage } from '@tabler/icons-react';
import { ShipmentSummaryProps } from './types';

const ShipmentSummary: React.FC<ShipmentSummaryProps> = ({ totalWeight, totalValue, packageCount }) => (
    <Card shadow="sm" padding="md" radius="md" withBorder>
        <Title order={3} mb="md" size="h4">Shipment Details</Title>

        {/* Mobile-optimized summary with icons */}
        <Grid gutter="md">
            <Grid.Col span={{ base: 12, xs: 4 }}>
                <Group gap="xs">
                    <ThemeIcon color="blue" variant="light" size="md" radius="xl">

                        <IconWeight size={16} />
                    </ThemeIcon>
                    <div>
                        <Text c="dimmed" size="xs">Total Weight</Text>
                        <Text size="sm" className="text-sm sm:text-md" fw={500}>{totalWeight} kg</Text>
                    </div>
                </Group>
            </Grid.Col>

            <Grid.Col span={{ base: 12, xs: 4 }}>
                <Group gap="xs">
                    <ThemeIcon color="green" variant="light" size="md" radius="xl">
                        <IconCoin size={16} />
                    </ThemeIcon>
                    <div>
                        <Text c="dimmed" size="xs">Total Value</Text>
                        <Text size="sm" className="text-sm sm:text-md" fw={500}>${totalValue.toFixed(2)}</Text>
                    </div>
                </Group>
            </Grid.Col>

            <Grid.Col span={{ base: 12, xs: 4 }}>
                <Group gap="xs">
                    <ThemeIcon color="violet" variant="light" size="md" radius="xl">
                        <IconPackage size={16} />
                    </ThemeIcon>
                    <div>
                        <Text c="dimmed" size="xs">Number of Packages</Text>
                        <Text size="sm" className="text-sm sm:text-md" fw={500}>
                            {packageCount} <Badge size="sm" variant="light">{packageCount > 1 ? 'items' : 'item'}</Badge>
                        </Text>
                    </div>
                </Group>
            </Grid.Col>
        </Grid>
    </Card>
);

export default ShipmentSummary;
